import { Linking, Platform } from 'react-native'

export function redirect(url: string) {
  if (Platform.OS === 'web') {
    window.location.href = url
  } else {
    Linking.openURL(url).catch(() => console.warn(`Unable to open ${url}.`))
  }
}
